import { Module } from 'vuex'
import { LevelUpDayState, RootState } from '../store/state_models'

/*
Usage
-----

In your component/page add a computed variable

computed: {
    isEnabled(){
        return this.$store.getters['LevelUpDayFlag/isfeatursActive']
    }
}
*/

export const LevelUpDayFlag: Module<LevelUpDayState, RootState> = {
  namespaced: true,
  state: {
    featuresActive: false,
    levelupDate: new Date('2025-10-13T10:00:00+05:30'),
  },
  getters: {
    isfeatursActive(){
     return true
    },
    isFeaturesActive2025(state: LevelUpDayState, getters: any, rootState: RootState, rootGetters: any) {
      try {
        const now = new Date()
        const exemptedAccounts = [
          'YuTUZlUtrwBtvmgByZDW', //Production CompanyId,
          'ktapXmiRvMM4pJHyN3b3', //Production CompanyId,
          '3LgYznDSGw7ot8zWLQ6G', //Production CompanyId - 297 Plan,
          'pPsvVAbsVXOQOdhyux8M', //Production CompanyId - 97 Plan,
          '5DP4iH6HLkQsiKESj6rh', //Staging CompanyId
          '0YMnBDiczHu4TuxrvGZo', //Staging CompanyId - Data Central497 - 497 Plan
          'HPHMMyoljIpqcEpYPrEM', //Staging CompanyId - Data Central297 - 297 Plan
          'gWzs7kHzdPsraM6r8isK', //Staging CompanyId - Data Central97 - 97 Plan
        ]

        const company = rootGetters['company/get']

        if (company?.id) {
          //there is no need to update the state.featuresActive as we are not using it anywhere
          return now >= state.levelupDate || exemptedAccounts.indexOf(company.id) > -1
        }

        return false
      } catch (error) {
        return false
      }
    },
  },
}
